import { render, staticRenderFns } from "./PSUSimpleTable.vue?vue&type=template&id=c1e0aa3c"
import script from "./PSUSimpleTable.vue?vue&type=script&lang=js"
export * from "./PSUSimpleTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports